import { observable } from "mobx";

export class PaymentInformation {
    @observable discountPrimary: number;
    @observable paymentTerms: number;

    constructor() {
        this.discountPrimary = 0;
        this.paymentTerms = 0;
    }
}